import BaseService from "@/boot/BaseService";
class PlanificacionService extends BaseService {
    constructor() {
        super(null, "/planificacion");
    }
    async getTasks(maquina, start, end) {
        return await this.post("/tasks", { maquina, start, end });
    }

    async fechasUpdate(formData) {
        return await this.post("/fechas", formData);
    }
}

export default new PlanificacionService();
